import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";

export default function AboutUs() {
    const { t } = useTranslation();

    // State for modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Sample image URLs (replace with actual company images)
    const images = [
        require("../../assets/company/DSC00010.JPG"),
        require("../../assets/company/DSC00022.JPG"),
        require("../../assets/company/DSC00030.JPG"),
        require("../../assets/company/DSC00041.JPG"),
        require("../../assets/company/DSC00051.JPG"),
        require("../../assets/company/DSC00092.JPG"),
        require("../../assets/company/DSC09993.JPG"),
        require("../../assets/company/DSC00049.JPG"),

    ];

    // Open modal with selected image
    const openModal = (index) => {
        setCurrentImageIndex(index);
        setIsModalOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Navigate to previous image
    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    // Navigate to next image
    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex items-center justify-between">
                    <div className="w-100 w-[48%] flex flex-col">
                        <div className="f-40 text-[50px] font-bold capitalize text-white">{t("About us")}</div>
                        <div className="font-bold text-white text-[20px] capitalize flex items-center gap-[7px]">
                            <Link to={"/"} className="text-white">{t("Home")}</Link>
                            -
                            <div className="text-white">{t("About us")}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="text-[#E56820]">{t("About")}</div>
                        <div className="text-[#E56820]">{t("Company")}</div>
                    </div>
                    <div className="flex flex-col gap-[15px] p-5 rounded-lg bg-[rgb(217_217_217_/_32%)] text-[21px]">
                        <p>{t("company_founded")}</p>
                        <p>{t("company_vision")}</p>
                        <p>{t("company_location")}</p>
                    </div>
                </div>
            </section>

            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="d-ar-none text-[#E56820]">{t("Our")}</div>
                        <div className="text-[#E56820]">{t("Principles")}</div>
                    </div>
                    <div className="flex flex-col gap-[15px] p-5 rounded-lg bg-[rgb(217_217_217_/_32%)] text-[21px]">
                        <p>{t("principles_text")}</p>
                    </div>
                </div>
            </section>

            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="d-ar-none text-[#E56820]">{t("Our")}</div>
                        <div className="text-[#E56820]">{t("Responsibilities")}</div>
                    </div>
                    <div className="flex flex-col gap-[15px] p-5 rounded-lg bg-[rgb(217_217_217_/_32%)] text-[21px]">
                        <p>{t("responsibilities_text")}</p>
                    </div>
                </div>
            </section>

            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="d-ar-none text-[#E56820]">{t("Our")}</div>
                        <div className="text-[#E56820]">{t("Goals")}</div>
                    </div>
                    <div className="flex flex-col gap-[15px] p-5 rounded-lg bg-[rgb(217_217_217_/_32%)] text-[21px]">
                        <p>{t("goals_text")}</p>
                    </div>
                </div>
            </section>

            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="d-ar-none text-[#E56820]">{t("Our")}</div>
                        <div className="text-[#E56820]">{t("Products")}</div>
                    </div>
                    <div className="flex flex-col gap-[15px] p-5 rounded-lg bg-[rgb(217_217_217_/_32%)] text-[21px]">
                        <p>{t("products_text")}</p>
                    </div>
                </div>
            </section>

            {/* New Section: Company Gallery */}
            <section className="relative py-[20px]">
                <div className="container">
                    <div className="main-title flex items-center gap-[6px] w-fit my-[30px] text-[40px] font-bold border-b-[5px] border-b-[#E56820]">
                        <div className="d-ar-none text-[#E56820]">{t("Our")}</div>
                        <div className="text-[#E56820]">{t("Gallery")}</div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-5 rounded-lg bg-[rgb(217_217_217_/_32%)]">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="relative overflow-hidden rounded-lg cursor-pointer group"
                                onClick={() => openModal(index)}
                            >
                                <img
                                    src={image}
                                    alt={`${t("company image")} ${index + 1}`}
                                    className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                                    <span className="text-white text-lg font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        {t("View Image")}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal for Image Popup */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                    <div className="relative max-w-4xl w-full mx-4">
                        <img
                            src={images[currentImageIndex]}
                            alt={`${t("company_image")} ${currentImageIndex + 1}`}
                            className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                        />
                        {/* Close Button */}
                        <button
                            onClick={closeModal}
                            className="absolute top-4 right-4 text-white bg-[#E56820] rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            &times;
                        </button>
                        {/* Previous Arrow */}
                        <button
                            onClick={prevImage}
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white bg-[#E56820] rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            &larr;
                        </button>
                        {/* Next Arrow */}
                        <button
                            onClick={nextImage}
                            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white bg-[#E56820] rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-[#c55a1b] transition-colors"
                        >
                            &rarr;
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}